import React,{ Fragment} from 'react'



export default function Documents() {

  return (
    <Fragment>
    <div className="py-12">
    <div className="max-w-7xl mx-auto px-4 xl:px-0  sm:px-6 md:px-8">
      <h1 className="text-3xl font-semibold text-gray-900" style={{color:"#E96036"}}>Documents</h1>
    </div>
    <div className="max-w-7xl mx-auto px-4 xl:px-0  sm:px-6 md:px-8">
      {/* Replace with your content */}
      <div className="py-4">
        <div className="border-4 border-dashed border-gray-200 rounded-lg h-96" />
      </div>
      {/* /End replace */}
    </div>
  </div>
  </Fragment>
  )
}